import { Binding } from "@ortho-next/three-base";
import { ViewType } from "../Models/AppModel.js";
import { Donut } from "../Tools/Primitive/Donut.js";
import { Label } from "../Tools/Primitive/Label/Label.js";
import { Consts } from "./Consts.js";
import { Utils } from "./Utils.js";
/**
 * Contains default data and function.
 */
export class Default {
    static get donut() { return Default._donut ?? (Default._donut = new Donut(0xFFAC1C, 0.5, 1.2, 0.7, -1, true)); }
    static get smallDonut() { return Default._smallDonut ?? (Default._smallDonut = new Donut(0xFFAC1C, 0.5, 0.4, 0.4, -1, true)); }
    static draggablePointDeselectOnHover(args) {
        args.object.circle.material.opacity = 0.3; //todo add to config
        args.object.needsRender = true;
    }
    static draggablePointSelectOnLeave(obj) {
        obj.circle.material.opacity = 0.6; //todo add to config
        obj.needsRender = true;
    }
    static colorAllDraggablePoints(activeTool) {
        const dragPoints = Utils.getAllDraggablePoints(activeTool);
        for (const obj of dragPoints) {
            Default.draggablePointSelectOnLeave(obj);
            obj.bindEvent("onHover", Default.draggablePointDeselectOnHover);
            obj.bindEvent("onLeave", Default.draggablePointSelectOnLeave);
        }
    }
    static restoreColorAllDraggablePoints(activeTool) {
        const dragPoints = Utils.getAllDraggablePoints(activeTool);
        for (const obj of dragPoints) {
            Default.draggablePointDeselectOnHover({ object: obj });
            obj.unbindEvent("onHover", Default.draggablePointDeselectOnHover);
            obj.unbindEvent("onLeave", Default.draggablePointSelectOnLeave);
        }
    }
    static scaleByScaleFactorPoints(obj) {
        obj.scale.setScalar(Consts.scaleFactorPoints);
    }
    static scaleByScaleFactorLabel(obj) {
        obj.scale.setScalar(Consts.scaleFactorLabel);
    }
    static bindHitboxScaleByScaleFactorAndZoom(viewType, obj) {
        if (!obj.objectsToRaycast) {
            console.error("bindHitboxScaleByScaleFactorAndZoom error: hitboxes not present.");
            return;
        }
        const propertyNameScaleHitbox = viewType === ViewType.AP ? "scaleHitboxAP" : "scaleHitboxLT";
        Binding.createCustom(`${obj.id}.hitboxes.scale`, m => 5 / Math.min(5, m[propertyNameScaleHitbox] * Consts.scaleFactorPoints), (v) => {
            for (const hitbox of obj.objectsToRaycast) {
                hitbox.scale.setScalar(v);
                hitbox.updateMatrix();
            }
        }, [propertyNameScaleHitbox]);
    }
    static bindHitboxScaleByZoom(viewType, obj) {
        if (!obj.objectsToRaycast) {
            console.error("bindHitboxScaleByAndZoom error: hitboxes not present.");
            return;
        }
        const propertyNameScaleHitbox = viewType === ViewType.AP ? "scaleHitboxAP" : "scaleHitboxLT";
        Binding.createCustom(`${obj.id}.hitboxes.scale`, m => 5 / Math.min(5, m[propertyNameScaleHitbox] * obj.scale.x), (v) => {
            for (const hitbox of obj.objectsToRaycast) {
                hitbox.scale.setScalar(v);
                hitbox.updateMatrix();
            }
        }, [propertyNameScaleHitbox]);
    }
    static bindOnEnabledChange_NoRaycastAndHiddenLabel(obj, excludedObjs, excludedObjsName) {
        obj.bindEvent("onEnabledChange", (value) => {
            obj.interceptedByRaycaster = value;
            const labels = Utils.getAllObjects(obj, Label, excludedObjs, excludedObjsName);
            for (const label of labels) {
                label.visible = value;
            }
        });
    }
}
//# sourceMappingURL=Default.js.map